import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

function Segmented({ value, onChange, options }) {
  return (
    <div className="inline-flex p-1 rounded-xl bg-gray-100 border border-gray-200">
      {options.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              active
                ? "bg-white text-gray-900 shadow-sm ring-1 ring-gray-200"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default function CategoryDesignSection({
  editedSection,
  t,
  flags,
  alignmentValue,
  setAlignment,
  onStyleChange,
}) {
  if (!flags?.isCategorySection) return null;

  const style = editedSection?.style || {};

  return (
    <>
      <EditorGroup
        title={t("sectionModal.category.cards.title", "Category Cards")}
        subtitle={t(
          "sectionModal.category.cards.help",
          "Control cards, borders, text, overlays and alignment for category templates"
        )}
        defaultOpen={false}
      >
        <div className="space-y-4">
          <div>
            <div className="text-sm font-medium text-gray-700 mb-2">
              {t("sectionModal.category.textAlign", "Text Alignment")}
            </div>

            <Segmented
              value={alignmentValue || "center"}
              onChange={setAlignment}
              options={[
                { value: "left", label: t("sectionModal.common.left", "Left") },
                { value: "center", label: t("sectionModal.common.center", "Center") },
                { value: "right", label: t("sectionModal.common.right", "Right") },
              ]}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.category.cardBg", "Card Background")}
              type="color"
              value={style.categoryCardBg}
              onChange={(v) => onStyleChange("categoryCardBg", v)}
            />
            <Field
              label={t("sectionModal.category.cardBorder", "Card Border")}
              type="color"
              value={style.categoryCardBorder}
              onChange={(v) => onStyleChange("categoryCardBorder", v)}
            />
            <Field
              label={t("sectionModal.category.cardTitleColor", "Card Title")}
              type="color"
              value={style.categoryCardTitleColor}
              onChange={(v) => onStyleChange("categoryCardTitleColor", v)}
            />
            <Field
              label={t("sectionModal.category.cardSubtitleColor", "Card Subtitle")}
              type="color"
              value={style.categoryCardSubtitleColor}
              onChange={(v) => onStyleChange("categoryCardSubtitleColor", v)}
            />
            <Field
              label={t("sectionModal.category.linkColor", "Link / Arrow Color")}
              type="color"
              value={style.categoryLinkColor}
              onChange={(v) => onStyleChange("categoryLinkColor", v)}
            />
            <Field
              label={t("sectionModal.category.imageOverlay", "Image Overlay")}
              type="color"
              value={style.categoryImageOverlayColor}
              onChange={(v) => onStyleChange("categoryImageOverlayColor", v)}
            />
          </div>
        </div>
      </EditorGroup>

      <EditorGroup
        title={t("sectionModal.category.featured.title", "Featured / Spotlight")}
        subtitle={t(
          "sectionModal.category.featured.help",
          "Colors for template 3 featured badge, panel and metric box"
        )}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.category.featuredBadgeBg", "Featured Badge Background")}
            type="color"
            value={style.categoryFeaturedBadgeBg}
            onChange={(v) => onStyleChange("categoryFeaturedBadgeBg", v)}
          />
          <Field
            label={t("sectionModal.category.featuredBadgeText", "Featured Badge Text")}
            type="color"
            value={style.categoryFeaturedBadgeText}
            onChange={(v) => onStyleChange("categoryFeaturedBadgeText", v)}
          />
          <Field
            label={t("sectionModal.category.featuredBadgeBorder", "Featured Badge Border")}
            type="color"
            value={style.categoryFeaturedBadgeBorder}
            onChange={(v) => onStyleChange("categoryFeaturedBadgeBorder", v)}
          />
          <Field
            label={t("sectionModal.category.featuredPanelBg", "Featured Bottom Panel Background")}
            type="color"
            value={style.categoryFeaturedPanelBg}
            onChange={(v) => onStyleChange("categoryFeaturedPanelBg", v)}
          />
          <Field
            label={t("sectionModal.category.featuredPanelBorder", "Featured Bottom Panel Border")}
            type="color"
            value={style.categoryFeaturedPanelBorder}
            onChange={(v) => onStyleChange("categoryFeaturedPanelBorder", v)}
          />
          <Field
            label={t("sectionModal.category.metricBoxBg", "Metric Box Background")}
            type="color"
            value={style.categoryMetricBoxBg}
            onChange={(v) => onStyleChange("categoryMetricBoxBg", v)}
          />
          <Field
            label={t("sectionModal.category.metricBoxBorder", "Metric Box Border")}
            type="color"
            value={style.categoryMetricBoxBorder}
            onChange={(v) => onStyleChange("categoryMetricBoxBorder", v)}
          />
          <Field
            label={t("sectionModal.category.metricLabelColor", "Metric Label")}
            type="color"
            value={style.categoryMetricLabelColor}
            onChange={(v) => onStyleChange("categoryMetricLabelColor", v)}
          />
          <Field
            label={t("sectionModal.category.metricValueColor", "Metric Value")}
            type="color"
            value={style.categoryMetricValueColor}
            onChange={(v) => onStyleChange("categoryMetricValueColor", v)}
          />
        </div>
      </EditorGroup>
    </>
  );
}